import { Controller } from "@hotwired/stimulus";

// Connects to data-controller="header-search-sp"
export default class extends Controller {
  static targets = ["searchWindow"];

  connect() {
    // 求人詳細ページではヘッダーはスクロールで流れる設計（position: relative）のため、
    // is_hide によるヘッダー開閉制御を行わない（ゲストバー固定の containing block を壊さないためにも必要）
    if (document.querySelector("#wrapper .jobDetail_nav")) return;

    this.startPos = 0;
    this.onScrollBound = this.onScroll.bind(this);
    window.addEventListener("scroll", this.onScrollBound, { passive: true });
  }

  disconnect() {
    if (!this.onScrollBound) return;

    window.removeEventListener("scroll", this.onScrollBound);
  }

  declare readonly searchWindowTarget: HTMLElement;

  private startPos: number = 0;

  private onScrollBound: (() => void) | null = null;

  /**
   * スクロール（上スクロール時検索窓を表示・下スクロール非表示）
   */
  onScroll(): void {
    // 検索窓選択時はスクロールしない
    if (!this.searchWindowTarget.classList.contains("is_fixed")) {
      // スクロール量の取得 iPhoneスクロールバインド対策
      const winScrollTop = window.scrollY;
      if (winScrollTop >= this.startPos && winScrollTop > 100) {
        // 上にスクロールしたとき
        this.searchWindowTarget.classList.add("is_hide");
      } else {
        // 下にスクロールしたとき
        this.searchWindowTarget.classList.remove("is_hide");
      }
      // 現在位置を更新
      this.startPos = winScrollTop;
    }
  }
}
